import htmx from "htmx.org";

import HtmxShoelaceExtension from "./utils/htmx-extensions";

import "./index.css";

await Promise.all([
  import("./utils/shoelace"),
  import("./utils/sentry"),
  import("./utils/icons"),
  import("./utils/alerts"),
]);

htmx.defineExtension("shoelace", HtmxShoelaceExtension);
window.htmx = htmx;

// Cleanup loading attributes
const removeLoadingAttributes = () => {
  // Find all elements with the 'loading' attribute and remove it
  const loadingElements = document.querySelectorAll("[loading]");
  loadingElements.forEach((element) => {
    element.removeAttribute("loading");
  });
};

const addLoadingAttributes = () => {
  // Find all forms with a sl-button submit button and add the 'loading' attribute on submit
  const forms = document.querySelectorAll("form:has(sl-button[type='submit'])");

  for (const form of forms) {
    form.addEventListener("submit", (e) => {
      const isLoading = form.hasAttribute("loading");
      if (isLoading) {
        e.preventDefault();
        return;
      }
      form.setAttribute("loading", "");
      const submitButtons = form.querySelectorAll("sl-button[type='submit']");
      for (const button of submitButtons) {
        button.setAttribute("loading", "");
      }
    });
  }
};

const initCode = () => {
  // This is needed to properly handle "Back" navigation
  htmx.on("htmx:responseError", removeLoadingAttributes);
  htmx.on("htmx:historyRestore", removeLoadingAttributes);
  addLoadingAttributes();
};

if (document.readyState !== "loading") {
  initCode();
} else {
  document.addEventListener("DOMContentLoaded", initCode);
}
